import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  isUserLoggedIn: () => {
    let isAuthenticated = false;

    const firebaseCurrentUser = firebase.auth().currentUser;

    if (firebaseCurrentUser) isAuthenticated = true;
    else isAuthenticated = false;

    return (localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`) && isAuthenticated);
  },
  permissions:[],
};
